export default __webpack_public_path__ + "static/media/Wiz.bae89622.svg";